import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Announcement } from '@app/core/interfaces/c5/announcement';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(announcement: Partial<Announcement>, file: File): Observable<Announcement> {
    const formData = new FormData();

    formData.append('colorRingBackTone', String(announcement.colorRingBackTone));
    formData.append('description', announcement.description);
    formData.append('domainId', String(announcement.domainId));
    formData.append('file', file, file.name);
    formData.append('type', announcement.type);
    formData.append('visibleByUser', String(announcement.visibleByUser));

    return this.utils
      .apiUrl(`/site/${announcement.domainId}/announcements`)
      .pipe(mergeMap((url) => this.http.post<Announcement>(url, formData)));
  }

  delete(id: number, siteId: number): Observable<void> {
    return this.utils.apiUrl(`/site/${siteId}/announcements/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('announcement-repository:delete')
    );
  }

  list(): Observable<Announcement[]> {
    return this.utils.apiUrl('/announcements').pipe(
      mergeMap((url) => this.http.get<Announcement[]>(url)),
      wrapError('announcement-repository:list')
    );
  }

  listForSite(siteId: number): Observable<Announcement[]> {
    return this.utils.apiUrl(`/site/${siteId}/announcements`).pipe(
      mergeMap((url) => this.http.get<Announcement[]>(url)),
      wrapError('announcement-repository:list-for-site')
    );
  }

  update(announcement: Announcement, file?: File): Observable<Announcement> {
    const formData = new FormData();

    Object.entries(announcement).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, String(value));
      }
    });

    if (file != null) {
      formData.append('file', file, file.name);
    }

    return this.utils.apiUrl(`/site/${announcement.domainId}/announcements`).pipe(
      mergeMap((url) => this.http.post<Announcement>(url, formData)),
      wrapError('announcement-repository:update')
    );
  }

  updateSetNightMode(announcement: Announcement): Observable<Announcement> {
    return this.utils.apiUrl(`/site/${announcement.domainId}/announcements/${announcement.id}`).pipe(
      mergeMap((url) => this.http.put<Announcement>(url, announcement)),
      wrapError('announcement-repository:update-set-night-mode')
    );
  }
}
